import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './deals-list.component.scss';
import Slider from '../slider/slider.component';
var DealsList = /** @class */ (function (_super) {
    tslib_1.__extends(DealsList, _super);
    function DealsList(element) {
        return _super.call(this, element) || this;
    }
    DealsList.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    DealsList.prototype.bindEvents = function () { };
    return DealsList;
}(Base));
export { DealsList };



//////////////////
// WEBPACK FOOTER
// ./components/deals-list/deals-list.component.ts
// module id = 256
// module chunks = 0